import {AdvisorCardProps} from '@/components/AdvisorCards/types'

import {fetcher} from '@/src/shared/lib/fetcher/fetcher'
import {transformGenderQuery} from '@/src/shared/utils/queryTransform'
import {PageableInterface} from '@/src/services/SearchService/types'

const API_URL = process.env.NEXT_PUBLIC_API_URL

export const advisorSearchWithKey = (
  key: string,
  size: number,
  page: number,
  queries?: {
    online: boolean
    free: boolean
    minprice: number
    genders: string
    maxprice: number
    ordering: string
  }
) => {
  return fetcher<PageableInterface<AdvisorCardProps>>({
    url: `${API_URL}/advisor-search/any`,
    method: 'POST',
    body: {
      key,
      size,
      page,
      gender: queries?.genders ? transformGenderQuery(queries?.genders) : null,
      max: queries?.maxprice,
      min:
        queries?.minprice && Number(queries?.minprice) > 100
          ? queries?.minprice
          : 100,
      online: queries?.online,
      free: queries?.free,
      arrangement: queries?.ordering || 'DEFAULT',
    },
  })
}
